<template>
  <div class="products-list-root">
    <scrollbar class="products-list-wrap" :class="{ 'light-theme': light }" id="products-list-wrap" :style="wrapStyle">
      <ul class="list-unstyled p-0 mb-0">
        <!-- 产品与服务：hover 展开可搜索面板 -->
        <li
          class="l1-menu-type l1-menu-type-products"
          :class="{ 'is-products-panel-open': productsPanelOpen }"
          @mouseenter="handleProductsServiceEnter"
          @mouseleave="handleProductsServiceLeave">
          <a class="d-flex align-items-center">
            <div class="l1-menu-type-icon flex-shrink-0 flex-grow-0">
              <icon type="menu-products" />
            </div>
            <div class="l1-menu-type-label flex-fill text-truncate mr-2" :title="$t('common.product_service')">{{ $t('common.product_service') }}</div>
            <div class="l1-menu-type-right-icon flex-shrink-0 flex-grow-0">
              <a-icon type="right" style="font-size: 12px;" />
            </div>
          </a>
        </li>
        <template v-for="(item, index) of menus">
          <li
            v-if="item.index !== 1 && item.menus && hasCascadeMenu(item)"
            v-show="productOpen"
            :key="index"
            class="l1-menu-item"
            :class="{ active: activeMenu.index === item.index, 'ant-popover-open': isL1CascadeOpen(item.index) }"
            @mouseenter="handleCascadeL1Enter(item, $event)"
            @mouseleave="handleCascadeL1Leave"
            @click="handleCascadeL1Click(item)">
            <a class="d-flex align-items-center">
              <div class="l1-menu-item-icon flex-shrink-0 flex-grow-0">
                <icon :type="item.meta.icon" />
              </div>
              <div class="l1-menu-item-label flex-fill text-truncate mr-2" :title="getLabel(item.meta)">{{ getLabel(item.meta) }}</div>
              <div class="l1-menu-item-right-icon flex-shrink-0 flex-grow-0">
                <a-icon type="right" style="font-size: 12px;" />
              </div>
            </a>
          </li>
          <li
            v-else
            v-show="productOpen"
            class="l1-menu-item"
            :class="{ active: item.index !== 1 && activeMenu.index === item.index }"
            :key="index">
            <a class="d-flex align-items-center" @click="handleL1LinkClick(item)">
              <div class="l1-menu-item-icon flex-shrink-0 flex-grow-0">
                <icon :type="item.meta.icon" />
              </div>
              <div class="l1-menu-item-label flex-fill text-truncate mr-2" :title="getLabel(item.meta)">{{ getLabel(item.meta) }}</div>
              <div v-if="item.index !== 1" class="l1-menu-item-right-icon flex-shrink-0 flex-grow-0">
                <a-icon type="right" style="font-size: 12px;" />
              </div>
            </a>
          </li>
      </template>
      <!-- 收藏 -->
      <li class="l1-menu-type" v-if="staredMenus.length">
        <a class="d-flex align-items-center">
          <div class="l1-menu-type-icon flex-shrink-0 flex-grow-0">
            <icon type="star" />
          </div>
          <div class="l1-menu-type-label flex-fill text-truncate mr-2" :title="$t('common.star_menu')">{{ $t('common.star_menu') }}</div>
        </a>
      </li>
      <draggable
        v-show="starOpen"
        handle=".drag-icon"
        ghost-class="ghost"
        :value="staredMenus"
        @change="handleDragChange">
        <transition-group type="transition" name="flip-list">
          <li class="l1-menu-star" v-for="item in staredMenus" :key="item.path">
            <a class="d-flex align-items-center" @click="handleL1StarClick(item)">
              <div class="l1-menu-left-icon flex-shrink-0 flex-grow-0 drag-icon">
                <icon :type="{ icon: getIcon(item.path), defaultIcon: 'star' }" />
              </div>
              <div class="l1-menu-star-label flex-fill text-truncate mr-2" :title="item.title">{{ item.title }}</div>
              <div class="l1-menu-star-right-icon l1-menu-star-icon flex-shrink-0 flex-grow-0 drag-icon" :title="$t('common.adjust_order')">
                <icon type="drag" style="transform: translateY(-2px)" />
              </div>
              <div class="l1-menu-star-right-icon flex-shrink-0 flex-grow-0" @click="e => handleUnStar(e, item)" :title="$t('common.remove_store')">
                <a-icon type="close" />
              </div>
            </a>
          </li>
        </transition-group>
      </draggable>
    </ul>
    </scrollbar>
    <menu-cascade-layer
      ref="cascadeLayer"
      :light="light"
      :get-label="getLabel"
      :show-menu="showMenu"
      @active-menu-change="handleActiveMenuChange"
      @scroll-to-section="handleScrollToSection"
      @router-change="handleCascadeRouterChange"
      @l1-open-change="handleL1OpenChange"
      @cascade-open-change="handleCascadeOpenChange"
      @update-stared-menu="handleUpdateStaredMenu" />
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import draggable from 'vuedraggable'
import * as R from 'ramda'
import { hasPermission } from '@/utils/auth'
import MenuCascadeLayer from './MenuCascadeLayer'
import { hasSubGroups } from './menuUtils'

export default {
  name: 'ProductsList',
  components: {
    draggable,
    MenuCascadeLayer,
  },
  props: {
    activeMenu: Object,
    menus: Array,
    staredMenus: Array,
    productsPanelOpen: Boolean,
  },
  data () {
    return {
      productOpen: true,
      starOpen: true,
      openL1Index: null,
    }
  },
  computed: {
    ...mapGetters(['theme', 'userInfo']),
    ...mapState('common', {
      staredList: state => state.sidebar.staredList,
    }),
    wrapStyle () {
      return {
        height: '100%',
      }
    },
    light () {
      return this.theme === 'light'
    },
  },
  methods: {
    getIcon (path = '') {
      return `res-${path.replace('/', '')}`
    },
    handleL1LinkClick (menu) {
      if (this.activeMenu?.index === menu.index) {
        this.$emit('activeMenuChange', { index: 1 })
        this.$nextTick(() => {
          this.$emit('activeMenuChange', menu)
        })
      } else {
        this.$emit('activeMenuChange', menu)
      }
      if (menu.index === 1) {
        this.$emit('routerChange', menu.menus[0].submenus[0])
        this.$emit('close')
      }
    },
    hasCascadeMenu (item) {
      return hasSubGroups(item, this.showMenu)
    },
    isL1CascadeOpen (index) {
      return this.openL1Index === index
    },
    handleProductsServiceEnter () {
      const layer = this.$refs.cascadeLayer
      if (layer) {
        layer.closeAll()
      }
      this.$emit('products-panel-open-change', true)
    },
    handleProductsServiceLeave () {
      this.$emit('products-panel-open-change', false)
    },
    handleCascadeL1Enter (item, event) {
      this.$emit('products-panel-open-change', false)
      const layer = this.$refs.cascadeLayer
      if (layer) {
        layer.openL1(item, event.currentTarget)
      }
    },
    handleCascadeL1Leave () {
      const layer = this.$refs.cascadeLayer
      if (layer) {
        layer.onL1MouseLeave()
      }
    },
    handleCascadeL1Click (item) {
      const layer = this.$refs.cascadeLayer
      if (layer) {
        layer.clickL1(item)
      }
    },
    handleL1OpenChange (index) {
      this.openL1Index = index
    },
    handleCascadeOpenChange (open) {
      this.$emit('cascade-open-change', open)
    },
    handleUpdateStaredMenu (list) {
      this.$emit('updateStaredMenu', list)
    },
    handleActiveMenuChange (menu) {
      if (this.activeMenu?.index === menu.index) {
        this.$emit('activeMenuChange', { index: 1 })
        this.$nextTick(() => {
          this.$emit('activeMenuChange', menu)
        })
      } else {
        this.$emit('activeMenuChange', menu)
      }
    },
    handleScrollToSection (payload) {
      this.$emit('scroll-to-section', payload)
    },
    handleCascadeRouterChange (menu) {
      this.$emit('routerChange', menu)
      this.$emit('close')
    },
    getMenuHidden (menu) {
      if (!R.isNil(menu.meta.hidden)) {
        if (R.is(Function, menu.meta.hidden)) {
          return menu.meta.hidden(this.userInfo, menu)
        }
        return menu.meta.hidden
      }
      if (!R.isNil(menu.meta.invisible)) {
        if (R.is(Function, menu.meta.invisible)) {
          return menu.meta.invisible(this.userInfo, menu)
        }
        return menu.meta.invisible
      }
      return false
    },
    showMenu (item) {
      const hidden = this.getMenuHidden(item)
      if (R.isNil(item.meta.permission) || R.isEmpty(item.meta.permission)) {
        return !hidden && true
      }
      return !hidden && hasPermission({ key: item.meta.permission })
    },
    handleL1StarClick (menu) {
      this.$emit('routerChange', menu)
      this.$emit('close')
    },
    handleUnStar (e, menu) {
      e.stopPropagation()
      const list = this.staredList.filter((item, index) => item !== menu.path)
      this.$emit('updateStaredMenu', list)
    },
    getLabel (meta) {
      if (meta.t) {
        return this.$t(meta.t)
      }
      return R.is(Function, meta.label) ? meta.label() : meta.label
    },
    handleDragChange (el) {
      const { element, oldIndex, newIndex } = el.moved
      const list = this.staredList.filter((item, index) => index !== oldIndex)
      list.splice(newIndex, 0, element.path)
      this.$emit('updateStaredMenu', list)
    },
  },
}
</script>

<style lang="less">
@import "../../../src/styles/less/theme";

.products-list-root {
  position: relative;
  flex: 0 0 200px;
  width: 200px;
  min-width: 200px;
  max-width: 200px;
  overflow: hidden;
  height: 100%;
}

.products-list-wrap {
  flex: 0 0 200px;
  background-color: @sidebar-dark-bg-color;
  .scrollbar-wrap {
    overflow-x: hidden;
  }
  &.light-theme {
    background-color: @sidebar-light-bg-color;
    border-right: 1px solid #e4e7ed;
    .l1-menu-item {
      > a {
        color: @sidebar-light-text-color;
      }
      &:hover {
        // background-color: @primary-1;
        > a {
          color: @primary-color!important;
        }
      }
      &.active {
        // background-color: @primary-1 !important;
        > a {
          color: @primary-color;
        }
      }
      &.ant-popover-open {
        > a {
          color: @primary-color!important;
        }
      }
      .l1-menu-item-right-icon {
        width: 26px;
        text-align: left;
        color: @sidebar-light-arrow-color;
        > i,
        .anticon {
          color: inherit;
        }
      }
      &:hover,
      &.active,
      &.ant-popover-open {
        .l1-menu-item-right-icon {
          color: inherit;
        }
      }
    }
    // 分类
    .l1-menu-type {
      border-top:1px solid #ddd;
      border-bottom:1px solid #ddd;
      background-color: @sidebar-light-text-bg-color;
      > a {
        color: @sidebar-light-text-color;
        cursor: default;
      }
      .l1-menu-type-right-icon {
        color: @sidebar-light-text-color!important;
      }
      &.l1-menu-type-products {
        > a {
          cursor: pointer;
        }
        &:hover > a,
        &.is-products-panel-open > a {
          color: @primary-color !important;
        }
        &:hover .l1-menu-type-right-icon,
        &.is-products-panel-open .l1-menu-type-right-icon {
          color: inherit !important;
        }
      }
    }
    // 收藏
    .l1-menu-star {
      > a {
        color: @sidebar-light-text-color;
      }
      &:hover {
        background-color: @sidebar-light-text-bg-color;
        > a {
          color: @primary-color!important;
        }
      }
    }
  }
}
// 分类
.l1-menu-type {
  border-top:1px solid #222;
  border-bottom:1px solid #222;
  background-color: @sidebar-dark-text-bg-color;
  > a {
    cursor: default;
    height: 44px;
    color: @sidebar-dark-text-color;
  }
  .l1-menu-type-icon {
    width: 50px;
    height: 18px;
    text-align: center;
    > i {
      font-size: 18px;
    }
  }
  .l1-menu-type-right-icon {
    width: 26px;
    text-align: left;
    > i {
      font-size: 12px;
    }
  }
  &.l1-menu-type-products {
    > a {
      cursor: pointer;
    }
    &:hover > a,
    &.is-products-panel-open > a {
      color: @sidebar-light-active-text-color !important;
    }
    &:hover .l1-menu-type-right-icon,
    &.is-products-panel-open .l1-menu-type-right-icon {
      color: inherit;
    }
  }
}
.l1-menu-item {
  > a {
    height: 44px;
    color: @sidebar-dark-text-color;
  }
  .l1-menu-item-icon {
    width: 50px;
    height: 18px;
    text-align: center;
    > i {
      font-size: 18px;
    }
  }
  .l1-menu-item-right-icon {
    width: 26px;
    text-align: left;
    color: @sidebar-dark-arrow-color;
    > i,
    .anticon {
      color: inherit;
    }
  }
  &.active,
  &:hover,
  &.ant-popover-open {
    .l1-menu-item-right-icon {
      color: inherit;
    }
  }
  &.active {
    // background-color: @primary-7 !important;
    > a {
      color: @sidebar-light-active-text-color;
    }
  }
  &:hover {
    // background-color: @sidebar-dark-text-bg-color;
    > a {
      color: @sidebar-light-active-text-color!important;
    }
  }
  &.ant-popover-open {
    > a {
      color: @sidebar-light-active-text-color!important;
    }
  }
}
// 收藏
.l1-menu-star {
  > a {
    height: 44px;
    color: @sidebar-dark-text-color;
  }
  .l1-menu-left-icon {
    width: 50px;
    height: 18px;
    text-align: center;
    > i {
      font-size: 16px;
    }
  }
  .l1-menu-star-icon {
    // opacity: 0;
    width: 50px;
    height: 18px;
    text-align: center;
    > i {
      font-size: 16px;
    }
    &:hover {
      cursor: move;
    }
  }
  .l1-menu-star-right-icon {
    // opacity: 0;
    // display: none;
    width: 26px;
    text-align: left;
    > i {
      font-size: 13px;
    }
  }

  &.active {
    // background-color: @sidebar-light-text-bg-color;
    > a {
      color: @primary-color;
    }
  }
  &:hover {
    background-color: @sidebar-dark-text-bg-color;
    > a {
      color: @primary-color!important;
    }
    // .l1-menu-star-icon {
    //   opacity: 0.9;
    // }
    // .l1-menu-star-right-icon {
    //   opacity: 1;
    //   display: inline-block;
    // }
  }
}

.flip-list-move {
  transition: transform 0.5s;
}
// .ghost {
//   opacity: 0.7;
// }
</style>
